var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('navbar',{attrs:{"storage_costumer":_vm.storage_costumer}}),_c('router-view'),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }